export default class PersonalityQuizPersonaPointsModel {
  public personaId: number = null;
  public points: number = null;
}
